<template>
  <v-container grid-list-xl text-xs-center>
    <v-form v-model="isUpdateValid">
      <v-layout row wrap>
        <v-flex lg6 v-if="departmentList.length == 0">
          <label class="blackLabel">Status Description:</label>
          <v-text-field label="Status Description" :rules="nameRules" v-model="objStatusEdit.description" solo
                        single-line></v-text-field>
        </v-flex>
        <v-flex lg12 v-if="departmentList.length != 0">
          <label class="blackLabel">Status Description:</label>
          <v-text-field label="Status Description" :rules="nameRules" v-model="objStatusEdit.description" solo
                        single-line></v-text-field>
        </v-flex>
        <v-flex lg12>
          <label class="blackLabel">Status Reasons: <small>( Too expensive, Timing, Not needed anymore etc
            )</small></label>
          <v-text-field label="Status Reasons" solo v-model="objStatusEdit.reasons" single-line required></v-text-field>
        </v-flex>
        <v-flex lg6 v-if="departmentList.length > 0 && fncCheckDeps()">
          <label class="blackLabel">* Status Department:</label>
          <small style="display: block; float: left;font-size:10px !important;">These departments will have access to:
            <strong>{{ globalModalParams.statusName }}</strong></small>
          <v-select :items="departmentList" v-model="objDepartments" item-value="id" item-text="name"
                    label="Status Department" autocomplete multiple solo></v-select>
          <!--<v-select :items="departmentList" v-model="objStatusEdit.department" item-value="id" item-text="name" label="Unassigned Status Department" autocomplete solo></v-select>-->
        </v-flex>
        <v-flex lg6 v-if="userRoles.length > 0 && departmentList.length != 0 && fncCheckDeps()">
          <label class="blackLabel">* Status Roles:</label>
          <small style="display: block; float: left;font-size:10px !important;">These roles will be able to change a
            quote to: <strong>{{ globalModalParams.statusName }}</strong></small>
          <v-select :items="userRoles" v-model="objRoles" item-value="id" item-text="name" label="Status Role"
                    autocomplete multiple solo></v-select>
        </v-flex>

        <v-flex lg12>
          <label class="blackLabel"><strong>PIPELINE STATUS GROUPING *</strong></label>
        </v-flex>
        <!--                <v-flex lg3>-->
        <!--                  <v-switch :disabled="currentSelected && currentSelected !== 'is_new_lead'" label="New Leads" v-model="objStatusEdit.is_new_lead"></v-switch>-->
        <!--                </v-flex>-->
        <v-flex lg3>
          <v-switch :disabled="currentSelected && currentSelected !== 'is_initial_engagement_quote'" label="Initial Engagement & Quoting" v-model="objStatusEdit.is_initial_engagement_quote"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch :disabled="currentSelected && currentSelected !== 'is_negotiating_customer_approval'"  label="Negotiating Customer Approval" v-model="objStatusEdit.is_negotiating_customer_approval"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch :disabled="currentSelected && currentSelected !== 'is_manufacturer_fulfilment'"  label="Manufacturer & Fulfilment" v-model="objStatusEdit.is_manufacturer_fulfilment"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch :disabled="currentSelected && currentSelected !== 'is_cancelled_expired_rejected'"  label="Cancelled, Expired or Rejected" v-model="objStatusEdit.is_cancelled_expired_rejected"></v-switch>
        </v-flex>

        <v-flex lg12>
          <label class="blackLabel"><strong>GENERAL STATUS FLAGS</strong></label>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Converted" v-model="objStatusEdit.is_converted"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="New Lead" v-model="objStatusEdit.is_new_lead"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Gathering Customer Requirements"
                    v-model="objStatusEdit.is_gathering_customer_reqs"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Quote Sent - Following Up" v-model="objStatusEdit.is_quote_sent"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Requote Requested" v-model="objStatusEdit.is_requote_requested"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Rejected" v-model="objStatusEdit.is_rejected"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Awaiting Acceptance" v-model="objStatusEdit.is_awaiting"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Requirements Sent to Design Team" v-model="objStatusEdit.is_reqs_sent_to_design_team"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Quote Completed by Design team" v-model="objStatusEdit.is_quote_completed_by_design_team"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Accepted Status" v-model="objStatusEdit.is_accepted"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Cancel Status" v-model="objStatusEdit.is_cancel"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Expired Status" v-model="objStatusEdit.is_expired"></v-switch>
        </v-flex>


        <v-flex lg12>
          <label class="blackLabel"><strong>STATUS API TRIGGERS</strong></label>
        </v-flex>

        <!--<v-flex lg3>
          <v-switch label="Creates an Order" v-model="objStatusEdit.is_order_status"></v-switch>
        </v-flex>-->
        <v-flex lg3 v-if="objAuthorize.manufacturer != '385889803'">
          <v-switch label="Locks Quote" v-model="objStatusEdit.is_lock"></v-switch>
        </v-flex>

        <!--<v-flex lg3>
          <v-switch label="Tender Winning Status" v-model="objStatusEdit.is_tender_winning"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Create Invoice" v-model="objStatusEdit.create_invoice"></v-switch>
        </v-flex>

        <v-flex lg3>
          <v-switch label="Triggers Notifications" v-model="objStatusEdit.triggers_notification"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Initial Tender Status" v-model="objStatusEdit.tender_status"></v-switch>
        </v-flex>

        <v-flex lg3>
          <v-switch label="Flag on Quote Report" v-model="objStatusEdit.colour_flag"></v-switch>
        </v-flex>-->
        <v-flex lg3>
          <v-switch
            v-if="globalModalParams.hasCheckedOut == false || objStatusEdit.description == globalModalParams.hasCheckedOutText"
            label="Checked Out Online" v-model="objStatusEdit.is_checked"></v-switch>
          <v-switch
            v-if="globalModalParams.hasCheckedOut == true && objStatusEdit.description != globalModalParams.hasCheckedOutText"
            :disabled="true" label="Checked Out Online" v-model="objStatusEdit.is_checked"></v-switch>
          <!--<small  v-if="globalModalParams.hasCheckedOut == true && objStatusEdit.description != globalModalParams.hasCheckedOutText" style="float: left;display: block; margin-top: -22px;font-size: 10px;"><strong>{{ globalModalParams.hasCheckedOutText }}</strong> marked as "Checked Out"</small>-->
          <small style="float: left;display: block; margin-top: -22px;font-size: 10px;">Reduces Stock</small>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer != '385889803'">
          <v-switch label="Show Order Button" v-model="objStatusEdit.is_vendor"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Customer Email Accept Final" v-model="objStatusEdit.is_customer_accept_final"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Customer Email Accept" v-model="objStatusEdit.is_customer_accept"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Customer Email Reject" v-model="objStatusEdit.is_customer_reject"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Request for Requote" v-model="objStatusEdit.is_reorder"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Dispatched Status" v-model="objStatusEdit.is_dispatched"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Picked Status" v-model="objStatusEdit.is_picked"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Print Status" v-model="objStatusEdit.is_print"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Send to Hybris Shopping List" v-model="objStatusEdit.is_hybris"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Send to Hybris Trolley" v-model="objStatusEdit.is_hybris_trolley"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Status that you cant move back from once payment has been made"
                    v-model="objStatusEdit.can_back_after_payment"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Status that you cant move passed before payment has been made"
                    v-model="objStatusEdit.can_forward_before_payment"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Manufactured Status" v-model="objStatusEdit.is_manufactured"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Delivered to Store Status" v-model="objStatusEdit.is_delivered_to_store"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Process Order" v-model="objStatusEdit.is_process_order"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Is Waiting For Tender" v-model="objStatusEdit.is_waiting_tender"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Is POD Uploaded" v-model="objStatusEdit.is_pod_uploaded"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Ignore For Reporting" v-model="objStatusEdit.is_ignore"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Send To Customer" v-model="objStatusEdit.is_customer_send"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="PO Received" v-model="objStatusEdit.is_po_received"></v-switch>
        </v-flex>
        <v-flex lg3>
          <v-switch label="Can Repeat Status From Email Button" v-model="objStatusEdit.is_status_repeat"></v-switch>
        </v-flex>
        <v-flex lg3>
          <label class="blackLabel">Status Color:</label>
          <swatches v-model="objStatusEdit.style_colour" colors="text-advanced" popover-to="right"/>
        </v-flex>
				<v-flex lg3>
					<label class="blackLabel">Status Color:</label>
					<swatches v-model="objStatusEdit.style_colour" colors="text-advanced" popover-to="right" />
				</v-flex>
        <v-flex lg12 v-if="objAuthorize.manufacturer != '385889803'">
          <label class="blackLabel"><strong>E-COMMERCE FLAG STATUS</strong></label>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.hide_ecommerce == 1">
          <v-switch label="Payment Cancelled" v-model="objStatusEdit.is_ecommerce_cancelled"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.hide_ecommerce == 1">
          <v-switch label="Payment Pending" v-model="objStatusEdit.is_ecommerce_pending"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.hide_ecommerce == 1">
          <v-switch label="Payment Successful" v-model="objStatusEdit.is_ecommerce_success"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.hide_ecommerce == 1">
          <v-switch label="Payment Failed" v-model="objStatusEdit.is_ecommerce_failed"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer != '385889803'">
          <v-switch label="Is Delivered" v-model="objStatusEdit.is_delivered"></v-switch>
        </v-flex>
        <v-flex lg12 v-if="objAuthorize.manufacturer == '385889803'">
          <label class="blackLabel"><strong>4SURE STATUSES</strong></label>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Installation In Progress Status" v-model="objStatusEdit.is_installation_wip"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Installation Complete Status"
                    v-model="objStatusEdit.is_installation_work_complete"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Job Completed" v-model="objStatusEdit.fs_job_complete"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Job Cancelled" v-model="objStatusEdit.fs_job_cancelled"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Awaiting Stock" v-model="objStatusEdit.fs_awaiting_stock"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="TL On Site" v-model="objStatusEdit.fs_on_site"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Work Paused" v-model="objStatusEdit.fs_work_paused"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="No Appointment" v-model="objStatusEdit.fs_no_appointment_contact_customer"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Ready For Delivery" v-model="objStatusEdit.fs_delivery_ready"></v-switch>
        </v-flex>

        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Installer Allocated" v-model="objStatusEdit.fs_installer_allocated"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Installer On Route - Stock Collect"
                    v-model="objStatusEdit.fs_installer_on_route_stock_collect"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Installer At Dispatch" v-model="objStatusEdit.fs_installer_at_dispatch"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Collection Cancelled" v-model="objStatusEdit.fs_collection_cancelled"></v-switch>
        </v-flex>
        <v-flex lg3 v-if="objAuthorize.manufacturer == '385889803'">
          <v-switch label="Installer On Route - Customer"
                    v-model="objStatusEdit.fs_installer_on_route_customer"></v-switch>
        </v-flex>

        <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder" style="margin-bottom: 0px !important;">
          <div style="float: right">
            <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
            <v-progress-circular indeterminate :width="3" :size="20" v-if="statusEdit == true" color="grey"
                                 class="pt-3 loginLoader"></v-progress-circular>
            <v-btn color="success" class="text-xs-right" v-if="!runEdit && statusEdit == false"
                   :disabled="!update_vars" @click.stop="fncUpdateStatus()">Update
            </v-btn>
            <small>* The button will activate once all required fields have been completed</small>
          </div>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex';
import Swatches from 'vue-swatches';
import "vue-swatches/dist/vue-swatches.min.css";

export default {
  name: 'Settings',
  components: {Swatches},
  data() {
    return {
      count: 0,
      currentSelected: null,
      found: false,
      objDepartments: [],
      objRoles: [],
      runEdit: false,
      isUpdateValid: false,
      nameRules: [
        v => !!v || 'Status name is required',
      ],
      colorRules: [
        v => !!v || 'Status color is required',
      ],
      orderRules: [
        v => !!v || 'Status order is required',
      ]
    };
  },
  methods: {
    fncCheckDeps() {
      return this.$store.getters.branchActive;
    },
    fncHideModal() {
      window.location.reload();
      // this.$store.commit('hideModal');
    },
    fncUpdateStatus() {
      let count = 0
      // if (this.objStatusEdit.is_new_lead){
      //   count++
      // }
      if (this.objStatusEdit.is_cancelled_expired_rejected){
        count++
      }
      if (this.objStatusEdit.is_initial_engagement_quote){
        count++
      }
      if (this.objStatusEdit.is_negotiating_customer_approval){
        count++
      }
      if (this.objStatusEdit.is_manufacturer_fulfilment){
        count++
      }

      if (count == 1) {
        this.$store.commit('setStatusEdit', true);
        this.runEdit = true;
        this.objStatusEdit.department = this.objDepartments;
        this.objStatusEdit.roles = this.objRoles;
        this.$store.dispatch({
          type: 'fncUpdateStatus',
          settings: {
            editStatus: this.objStatusEdit
          }
        });
        this.runEdit = false;
      }
      else if (count > 1){
        alert('Only one Pipeline Grouping status should be selected !')
      }
    },
    fncCreateForm() {
    }
  },
  computed: {
    ...mapGetters([
      'objAuthorize',
      'statusList',
      'globalModalParams',
      'objStatusEdit',
      'departmentList',
      'userRoles',
      'statusEdit'
    ]),
    update_vars(){
      if (this.isUpdateValid && this.found)
        return  true
      else
        return  false
    }
  },
  beforeMount() {
    this.$store.dispatch('fncPopulateDepartments');
    this.$store.dispatch('fncPopulateRoles');
  },
  watch: {
    objStatusEdit:{
      deep:true,
      handler(value) {
        if (value.is_cancelled_expired_rejected){
          this.currentSelected = 'is_cancelled_expired_rejected'
          this.found = true
        }
        else if (value.is_initial_engagement_quote){
          this.currentSelected = 'is_initial_engagement_quote'
          this.found = true
        }
        else if (value.is_negotiating_customer_approval){
          this.found = true
          this.currentSelected = 'is_negotiating_customer_approval'
        }
        else if (value.is_manufacturer_fulfilment){
          this.found = true
          this.currentSelected = 'is_manufacturer_fulfilment'
        }
        else{
          this.currentSelected = null
          this.found = false
        }
      }
    }
  },
  mounted() {

    if (this.objStatusEdit.is_cancelled_expired_rejected)
      this.found = true
    else if (this.objStatusEdit.is_initial_engagement_quote)
      this.found = true
    else if (this.objStatusEdit.is_negotiating_customer_approval)
      this.found = true
    else if (this.objStatusEdit.is_manufacturer_fulfilment)
      this.found = true
    else
      this.found = false

    if (this.objStatusEdit.department != null) {
      this.objDepartments = this.objStatusEdit.department.split(',');
      var objDeps = [];

      for (var r in this.objDepartments) {
        objDeps.push(parseInt(this.objDepartments[r]));
      }
      this.objDepartments = objDeps;
    } else {
      this.objDepartments = [];
    }

    if (this.objStatusEdit.roles != null) {
      var splitRoles = this.objStatusEdit.roles.split(',');
      var objRoles = [];

      for (var r in splitRoles) {
        objRoles.push(parseInt(splitRoles[r]));
      }

      this.objRoles = objRoles;
    } else {
      this.objRoles = [];
    }

  }
}
</script>

<style scoped>
/*@import '../../assets/css/shared.css'*/
</style>
